import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash/lang';
import globalMessages from 'containers/App/messages';
import { isFieldEmpty } from 'utils/form';
import numeral from 'numeral';
import { getMinValue, getMaxValue } from '../../helper';

const validate = (values, props) => {
  const errors = {};
  const dtaConfig = props.dtaConfig;
  const lifeAssured = props.lifeAssured;

  if (!values.isEmpty()) {
    const offerCodeValues = values.get('offerCode');
    const startDateValues = values.get('startDate');
    const currencyValues = values.get('currency');
    const termValues = values.get('term');
    const paymentFrequencyValues = values.get('paymentFrequency');
    const coveragesValues = values.get('coverages');

    if (!startDateValues || !moment(startDateValues).isValid()) {
      errors.startDate = (
        <FormattedMessage {...globalMessages.pleaseEnterValue} />
      );
    }

    if (!currencyValues || currencyValues === 'Select')
      errors.currency = (
        <FormattedMessage {...globalMessages.pleaseEnterValue} />
      );

    if (!termValues || termValues === 'Select')
      errors.term = <FormattedMessage {...globalMessages.pleaseEnterValue} />;
    else {
      if (dtaConfig.features.policyTerm.minTerm > termValues) {
        errors.term = (
          <FormattedMessage
            {...globalMessages.minValueLimit}
            values={{ value: dtaConfig.features.policyTerm.minTerm }}
          />
        );
      }

      if (dtaConfig.features.policyTerm.maxTerm < termValues) {
        errors.term = (
          <FormattedMessage
            {...globalMessages.maxValueLimit}
            values={{ value: dtaConfig.features.policyTerm.maxTerm }}
          />
        );
      }
    }

    if (!paymentFrequencyValues || paymentFrequencyValues === 'Select')
      errors.paymentFrequency = (
        <FormattedMessage {...globalMessages.pleaseEnterValue} />
      );

    if (coveragesValues && coveragesValues.size > 0) {
      const coveragesError = [];
      var lfcInsuredOne = 0;
      var lfcInsuredTwo = 0;
      coveragesValues.map(coverage => {
        const requiredCoverageFields = lifeAssured.isInsuredTwo
          ? ['valueInsuredOne', 'valueInsuredTwo']
          : ['valueInsuredOne'];
        const coverageError = {};

        if (coverage.get('id') === 'LFC') {
          lfcInsuredOne = coverage.get('valueInsuredOne');
          lfcInsuredTwo = coverage.get('valueInsuredTwo');
        }

        requiredCoverageFields.forEach(field => {
          if (coverage.get('selected')) {
            if (isFieldEmpty(coverage.get(field))) {
              coverageError[field] = (
                <FormattedMessage {...globalMessages.pleaseEnterValue} />
              );
            } else if (coverage.get('type') === '1') {
              const minVal = getMinValue(
                coverage.get('id'),
                dtaConfig.features,
                currencyValues,
              );
              const maxVal = getMaxValue(
                coverage.get('id'),
                dtaConfig.features,
                currencyValues,
              );

              if (minVal > coverage.get(field))
                coverageError[field] = (
                  <FormattedMessage
                    {...globalMessages.minAmountLimit}
                    values={{ value: minVal }}
                  />
                );

              if (maxVal < coverage.get(field))
                coverageError[field] = (
                  <FormattedMessage
                    {...globalMessages.maxAmountLimit}
                    values={{ value: maxVal }}
                  />
                );

              if (
                numeral(coverage.get('valueInsuredOne')).value() >
                numeral(lfcInsuredOne).value()
              )
                coverageError[field] = (
                  <FormattedMessage {...globalMessages.accelerateValidation} />
                );

              if (
                numeral(coverage.get('valueInsuredTwo')).value() >
                numeral(lfcInsuredTwo).value
              )
                coverageError[field] = (
                  <FormattedMessage {...globalMessages.accelerateValidation} />
                );
            }
          }
        });
        coveragesError.push(coverageError);
      });

      if (!isEmpty(coveragesError)) errors.coverages = coveragesError;
    }

    if (!isEmpty(offerCodeValues)) {
      const coverages = coveragesValues.toJS();
      const lifeCover = coverages.find(item => item.id === 'LFC');
      if (lifeCover?.valueInsuredOne === '') {
        errors.offerCode = (
          <FormattedMessage {...globalMessages.pleaseSelectLifeCover} />
        );
      }
      if (currencyValues === 'Select') {
        errors.offerCode = (
          <FormattedMessage {...globalMessages.pleaseSelectCurrency} />
        );
      }
      if (termValues === 'Select') {
        errors.offerCode = (
          <FormattedMessage {...globalMessages.pleaseSelectPolicyTerm} />
        );
      }
    }
  }
  return errors;
};

export default validate;
